import React from 'react';
import PropTypes from 'prop-types';
import HeaderContext from './HeaderContext';
var GlobalState = function GlobalState(_ref) {
  var children = _ref.children,
    initState = _ref.initState;
  //TODO: Add any fetching and handling of centralized state here
  var clubId = initState.clubId,
    teamData = initState.teamData,
    teamNameDisplay = initState.teamNameDisplay,
    styleProps = initState.styleProps,
    teamNameSlug = initState.teamNameSlug,
    locale = initState.locale,
    navVariables = initState.navVariables;
  return /*#__PURE__*/React.createElement(HeaderContext.Provider, {
    value: {
      isClub: !['mlb', 'milb'].includes(clubId),
      clubId: clubId,
      teamData: teamData,
      teamNameDisplay: teamNameDisplay,
      styleProps: styleProps,
      teamNameSlug: teamNameSlug,
      locale: locale,
      navVariables: navVariables
    }
  }, children);
};
GlobalState.propTypes = {
  children: PropTypes.element.isRequired,
  initState: PropTypes.shape({
    clubId: PropTypes.string.isRequired,
    styleProps: PropTypes.shape({}).isRequired,
    teamData: PropTypes.object,
    teamNameDisplay: PropTypes.string,
    teamNameSlug: PropTypes.string,
    locale: PropTypes.string,
    navVariables: PropTypes.shape({
      sitesearch: PropTypes.bool,
      accountsearch: PropTypes.bool
    })
  }).isRequired
};
export default GlobalState;